import React from 'react';
// import ReactDOM from 'react-dom';
import GongqiFormItem from './GongqiFormItem';
import CommandResolver from '../utils/CommandResolver';
import CommandTask from '../forms/sys/remote/CommandTask';
import TreeRefreshArg from '../forms/sys/remote/TreeRefreshArg';
import Cmd from '../forms/sys/remote/Cmd';
import {CommandMapEditorsStore} from '../stores/CommandStore';
import {RefreshPluginStore} from '../stores/CmdTypeStore';
import Fade from '../utils/Fade';

require('../styles/FormItemPluginStyle.css')
export default class FormItemPluginAttachment extends GongqiFormItem
{

	constructor(props)
	{
		super(props);
		this.serviceURL = window.parent.window.userInfos.serviceURL;
		this.resourceURL = window.parent.window.userInfos.resourceURL;
		this.width = this.props.control.width;
        this.state = {
			task:false,
			fileList:[],
			returnFileList:[],
			AttachmentFileList:[],
			// selectedIndex:'0',
			renameIsShow:false,
			coverIsShow:false
        }
		this.unsubscribeCommandMapEditorsStore = CommandMapEditorsStore.listen(this.onMapEditorsHandler.bind(this));
        this.unsubscribeRefreshPluginStore = RefreshPluginStore.listen(this.onRefresh.bind(this));
	}

	componentWillUnmount()
	{
		this.unsubscribeCommandMapEditorsStore();
		this.unsubscribeRefreshPluginStore();
	}

	componentDidMount()
	{
        let key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
        if (window.hasOwnProperty(key)) {
		  let pluginLaterArg = window[key];
		  let tasks = pluginLaterArg.tasks;
		  for(let i = 0;i<tasks.length;i++)
		  {
			  this.refresh(tasks[i]);
		  }
          window[key] = null;
          delete window[key];
        }
	}
	
	componentDidUpdate()
	{

	}

	onRefresh(task,pluginName,formId,result)
	{
		if(this.props.xml.name == pluginName && this.props.formId == formId)
		{
			result.push(this.props.xml.name);
			this.refresh(task);
		}
    }
    
    onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if(this.props.moduleInstanceId != moduleInstanceId)
			return;
		if(selector!="all" && this.props.xml.name != selector)
			return;

		
		var returnFileList = this.state.returnFileList;
		// if(returnFileList){
		// 	var id = this.state.returnFileList[0];
		// }else{
		// 	var id = "";
		// }
		// var arr = [];
		// arr.push(id);
		
		mapEditorValues[this.props.xml.name] = returnFileList;
		return;
	}

	refresh(task)
	{
		console.log(task);
		// var attachments = task.arg.attachments
		var data =task;
		(function(data){
			this.setState({
				task:data,
				AttachmentFileList: data.arg.attachments
			});
			// console.log(this.state.data);
		}).call(this,data);
		// this.setState({
		// 	task:task,
		// 	AttachmentFileList: attachments
		// });
		var AttachmentFileList = data.arg.attachments;
		var list= [];
		var idlist = [];
		if(AttachmentFileList.length > 0){
			for(var i = 0 ; i < AttachmentFileList.length ; i++){
				list.push(AttachmentFileList[i].attachmentName);
				idlist.push(AttachmentFileList[i].attachmentId);
			}
			this.setState({
				fileList:list,
				returnFileList: idlist
			})
		}
		if(!task.arg.allowEditor){
			$(this.uploaderButton).css("display","none");
		}
    }
    
    btnUpLoad_clickHandler(){
        // alert("2");
		$(this.uploaderInput).click();
    }
    
    upLoaderChangeHandler(e){
		var uploadFiles = e.target.files || e.dataTransfer.files;
        var uploadFile = uploadFiles[0];
        if(uploadFile){
		    this.fileSelectedHandler(uploadFile);
        }
    }
    
    doFileSelected(uploadFile){
		var fileList=this.state.fileList;
		var fileName=uploadFile.name;
		this.uploadFile=uploadFile;
		if(fileList.length>0&&fileList.indexOf(fileName)>-1){
			this.setState({coverIsShow:true});
			
		}else{
			this.upLoadFileHandler();
		}
	}

    fileSelectedHandler(uploadFile){
		
		if(uploadFile.size > 100*1024*1024){
			var options={
				text:'要上传的文件不允许超过100M'
			}
			Fade.show(options);
		}else{
			this.doFileSelected(uploadFile);
		}

    }
    
    upLoadFileHandler(){
		var dataItemId = this.state.task.arg.dataItemId;
        var uploadFile=this.uploadFile;
		this.setState({coverIsShow:false})
		var fileName=uploadFile.name;
		// var tableId=this.state.tableId;
		// var recId=this.state.recId;
				    //web/apps/gongqi.oa.bpm/attachment/upload/
		var path = "web/apps/gongqi.oa.bpm/attachment/upload/" + dataItemId ;
		// var serviceURL=this.serviceURL;
		var url=encodeURI(path);
		// var url = "http://192.168.1.140:10201/web/bpm/attachment/upload/"+dataItemId;




		var oMyForm = new FormData();    
        oMyForm.append("attachmentFile", uploadFile);
        this.client=new XMLHttpRequest();
        var progressBar=$('<progress></progress>').css({'width':'15em','height':'2.1em'}).html('您的浏览器不支持progress元素');
        var that=this;
        var progressA=$('<a></a>').css({'background-color':'#fff','color':'#ff0000','font-size':'1.5em'}).click(function(){that.client.abort()}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
        var progressBtn=$('<div></div>').append(progressA);
        var progressDiv=$('<div></div>').css({'position':'absolute','top':'40.5%','left':'40%','display':'flex'}).append(progressBar).append(progressBtn);
        var percentageDiv=$('<span></span>');
        var time=$("<span></span>");
        var percentDiv=$('<div></div>').css({'position':'absolute','top':'41%','left':'40.5%','font-size':'0.8em'}).append(percentageDiv).append(time);
        var progressBorder=$("<div></div>").append(progressDiv).append(percentDiv).attr('id','progressBorder').addClass('modal');
        $('body').append(progressBorder);
        
        this.client.upload.onprogress = function(pe) {
        	
	        if(pe.lengthComputable) {
	        	progressBorder.css('display','block');
	         	progressBar.attr('max',pe.total);
	        	progressBar.attr('value',pe.loaded);
	         	percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");
	        }
	        var nt = new Date().getTime();//获取当前时间
	        var pertime = (nt-this.ot)/1000; //计算出上次调用该方法时到现在的时间差，单位为s
	        this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
	        var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b       
	        this.oloaded = pe.loaded;//重新赋值已上传文件大小，用以下次计算
	                    
	        //上传速度计算
	        var speed = perload/pertime;//单位b/s
	        var bspeed = speed;
	        var units = 'b/s';//单位名称
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'k/s';
	        }
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'M/s';
	        }
	        speed = speed.toFixed(1);
                        //剩余时间
        	var resttime = ((pe.total-pe.loaded)/bspeed).toFixed(1);
	        
	        var timeContent=' '+speed+units+'，剩余时间：'+resttime+'s';
	        time.html(timeContent); 
	    }

	    this.client.upload.onloadstart = function(){//上传开始执行方法
	        this.ot = new Date().getTime();   //设置上传开始时间
	        this.oloaded = 0;//设置上传开始时，以上传的文件大小为0
	    };
	    this.client.onreadystatechange=this.uploadStateChangeHandler.bind(this,fileName,uploadFile);
	                
	    this.client.open("POST", url,true);//+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
	    this.client.withCredentials = true;
	               
	    this.client.onloadend = function(pe) {
	            // document.getElementById('progressDiv').style.display='none';
	        $('#progressBorder').remove();
	        
	    }
	    this.client.send(oMyForm);
    }
    uploadStateChangeHandler(fileName,uploadFile)
	{
		var that=this;
		if (this.client.readyState==4)
	    {// 4 = "loaded"
	  		if (this.client.status==200)
	    	{	
	    		var options={
	    			state:'success',
	    			text:'上传成功！'
	    		}
	    		Fade.show(options);
				//更新列表

				console.log(this.client.responseText);
				var responseText = JSON.parse(this.client.responseText);
				var data = responseText.content;
				var returnfileidarr = this.state.returnFileList;
				
				//this.doRefresh();
	    		var fileList = this.state.fileList;
	    		var attachmentfilelist = this.state.AttachmentFileList
	    		if(fileList.indexOf(fileName)==-1){
					fileList.push(fileName);
					attachmentfilelist.push(uploadFile);
					returnfileidarr.push(data.attachmentId);
	    			this.setState({
						fileList:fileList,
						AttachmentFileList:attachmentfilelist,
						returnFileList : returnfileidarr
					});
				}

	    		var _parentWindow = window.parent.window;
			  	if(_parentWindow)
			  	{
				    _parentWindow.updateAttachmentNum(fileList.length);
				}
				window.updateAttachmentNum(fileList.length);
	    	}
		  	else
		    {
		    	var options={
		    		state:'error',
	    			text:'上传失败！'
	    		}
	    		Fade.show(options);
		    }
	  	}	
	  	$(this.uploaderInput).val('');
	}

	getTableContent(){
		var fileList=this.state.fileList;
		var tableContent=[];
		var that=this;
		var task = this.state.task;
		var allowEditor = false;
		var returnFileList = this.state.returnFileList;
		var AttachmentFileList = this.state.AttachmentFileList;
		if(task){
			allowEditor = task.arg.allowEditor;
		}
		if(fileList.length==0){

		}else{
			for(var i=0;i<fileList.length;i++){
				var fileName = fileList[i];
				var attachmentId = returnFileList[i];
				var filesize = AttachmentFileList[i].attachmentSize;
				var displaystyle;
				var href = "web/apps/gongqi.oa.bpm/attachment/download/" + attachmentId+"/"+fileName;
				if(allowEditor){
					displaystyle = "block";
				}else{
					displaystyle = "none";
				}
				let f =fileName;
				tableContent.push(
					<tr>
						<td><a href={href} target="_blank" >{fileName}</a></td>
						<td style={{float:'right',textAlign:'center'}} >
							<a>{filesize}</a>
							<span>&emsp;</span>
							<a href={href}  target="_blank" disable={!allowEditor}><i className="fa fa-download"></i>下载</a>
							<span>&emsp;</span>
							<a title={fileName} onClick={()=>that.btnDelete_clickHandler(f)} style={{display:displaystyle}}><i title={fileName} className="fa fa-minus"></i>删除</a>
						</td>
					</tr>
				);
				
			}
		}
		return tableContent;
	}

	btnDelete_clickHandler(fileName){
		//删除
		// let fileName = $(e.target).attr("title");
		var fileList = this.state.fileList;
		var attachmentfilelist = this.state.AttachmentFileList;
		var returnFileList = this.state.returnFileList;
		if(fileList.length==0){

		}else{
			for(var i=0;i<fileList.length;i++){
				var name=fileList[i];
				if(name == fileName){
					fileList.splice($.inArray(name, fileList), 1);
					attachmentfilelist.splice($.inArray(attachmentfilelist[i], attachmentfilelist), 1);
					returnFileList.splice($.inArray(returnFileList[i], returnFileList), 1);
				}
			}
			this.setState({
				fileList:fileList,
				AttachmentFileList:attachmentfilelist,
				returnFileList:returnFileList
			})
		}
	}

	btnDownLoad_clickHandler(fileName) {
		//下载
		// alert("download");
		// var selectedIndex=this.state.selectedIndex;
		// var fileList=this.state.fileList;
		// var selectedItem;
		// var returnFileList = this.state.returnFileList;
		// if(fileList.length==0){

		// }else{
		// 	for(var i=0;i<fileList.length;i++){
		// 		var name=fileList[i];
		// 		if(name == fileName){
		// 			selectedItem = returnFileList[i];
		// 		}
		// 	}
		// }
		// // var selectedItem=fileList[selectedIndex];
		// if(selectedItem == null || selectedItem == "")
		// 	return;
		// var base=this.resourceURL;
		// // var tableId=this.state.tableId;
		// // var recId=this.state.recId;
		// var dataItemId = this.state.task.arg.dataItemId;
		// // var url=base+"web/bpm/attachment/dowmnload/" + selectedItem;
		// var url = "web/bpm/attachment/dowmnload/" + selectedItem;
		// // /GongqiERP/resource/attachments/30102106/1993897950/loading.gif
		// // var url='http://www.gongqi.info:10208/bin/'+selectedItem;
		// if(typeof url == 'object' && url instanceof Blob)
		// {
		// 	url = URL.createObjectURL(url); // 创建blob地址
		// }
	    // var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
	    // a.href = url;
	    // a.download = selectedItem;
	   
	    // var e = document.createEvent('MouseEvents');
	    // e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	    // a.dispatchEvent(e);
	    // URL.revokeObjectURL(url);
	}


	render()
	{
		var tableContent = this.getTableContent();
        return(
            <div id={this.props.xml.name} className="gongqiPluginAttachment" style={{width:'100%'}}>
                <div style={{padding:' 0 100px'}}>
					<table className="table" style={{marginBottom:'0px'}}>
						<tbody>{tableContent}</tbody>
					</table>
                </div>
                <div style={{padding:'0 100px'}}>
                    <input type="file" accept="*" multiple="false"  style={{display:'none'}} ref={node => this.uploaderInput = node} onChange={this.upLoaderChangeHandler.bind(this)}/>
                    <button type="button" ref={node => this.uploaderButton = node} className="btn btn-default" style={{width:'100%',background:'#fff',border:'1px dashed #ccc'}} onClick={this.btnUpLoad_clickHandler.bind(this)}>点击上传</button>
                </div>
            </div>
        )
	}

}


// WEBPACK FOOTER //
// ./src/formItem/FormItemPluginAttachment.js